import { render } from "./AccessInfoModal.vue?vue&type=template&id=00dde504&scoped=true"
import script from "./AccessInfoModal.vue?vue&type=script&lang=js"
export * from "./AccessInfoModal.vue?vue&type=script&lang=js"

import "./AccessInfoModal.vue?vue&type=style&index=0&id=00dde504&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00dde504"]])

export default __exports__